import React from "react";

const NotificationItem = ({ message }) => {
  return (
    <div className="messagedate noborder">
      <h5> {message} </h5>
    </div>
  );
};

export default NotificationItem;
